import { render, staticRenderFns } from "./congresoGrafico.vue?vue&type=template&id=25127fd7&"
import script from "./congresoGrafico.vue?vue&type=script&lang=js&"
export * from "./congresoGrafico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports